export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DatabaseWorker.1bf1efa4.worker.js");
}
